/**
 * 工单年度等级统计组件
 */

import { useEffect, useState } from 'react';
import { Chart } from '@antv/g2';
import $ from 'jquery';
import {
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

var date = new Date();
const CURRENTYEAR = date.getFullYear();

const WOWDCL = (props) => {
    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                // 获取数据
                const params = {
                    'start_date': CURRENTYEAR + '-01-01',
                    'end_date': CURRENTYEAR + '-12-31',
                }
                $.ajax({
                    url: `${CNF.plmsApi}reports/wo/wdcl${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            setData(data.dat);
                            setIsRefresh(false);
                        }
                    }
                })
            }
        }
    }, [props, isRefresh]);

    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id-wowdcl',
            autoFit: true,
        });

        chart.data(data);

        chart
            .interval()
            .encode('x', 'type')
            .encode('y', 'count')
            .encode('color', 'type')
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '日期', })
            .axis('y', {
                title: '数量',
                labelFormatter: (d) => `${d > 10000 ? (d / 10000).toFixed(CNF.DPL) : d}`
            })
            .animate('enter', {
                type: 'scaleInY',
                duration: CNF.animateDuration,
            },)
            .tooltip({
                items: [
                    (d) => {
                        return { channel: 'y', value: `${d.count}个`, }
                    },
                ],
            })
            .style('minWidth', 40)
            .style('maxWidth', 60);
        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props, data]);

    return <div id='antv-g2-id-wowdcl'></div>
}

export default WOWDCL;